<template>
  <v-app>
    <snackbar></snackbar>
    <c-loader></c-loader>
    <v-main>
      <v-snackbar
        v-model="connectionStatus.display"
        :timeout="2500"
        absolute
        outlined
        center
        :color="connectionStatus.type"
        top
      >
        <div>
          {{ connectionStatus.content }}
        </div>
      </v-snackbar>
      <router-view></router-view>
      <v-progress-linear
        v-if="loadingBar.display"
        id="app-loading-bar"
        indeterminate
        color="yellow darken-2"
      ></v-progress-linear>
    </v-main>
  </v-app>
</template>

<script>
import CLoader from '@/components/c-loader/c-loader.vue';
import Snackbar from './components/snackbar/snackbar.vue';
export default {
  name: 'App',

  components: {
    CLoader,
    Snackbar,
  },

  Snackbardata: () => ({}),
  computed: {
    connectionStatus: {
      get() {
        return this.$store.state.ui.alertParams;
      },
      set(value) {
        this.$store.commit('ui/setAlertState', value);
      },
    },
    loadingBar() {
      return this.$store.state.ui.loadingBar;
    },
  },
  created() {
    const isLoggedIn = window.$cookies.isKey(process.env.VUE_APP_COOKIE_NAME)
    if (isLoggedIn) {
      this.loadStore()
    }
  },
  methods: {
    loadStore() {
      this.$store.dispatch('segments/getSegments')
      this.$store.dispatch('scenarios/scenariosData')
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/main.scss';
@import '@/styles/typography.scss';
@import '@/styles/buttons.scss';
@import '@/styles/menu.scss';
@import '@/styles/cards.scss';
@import '@/styles/tables.scss';
@import '@/styles/dialog.scss';
@import '@/styles/switch.scss';

#app-loading-bar {
  position: absolute;
  top: 0px;
}
</style>
